import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import makeStyles from '@material-ui/core/styles/makeStyles'
import React from 'react'
import Typography from '@material-ui/core/Typography'
import WarningOutlined from '@material-ui/icons/WarningOutlined'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    padding: '0 16px',
    textAlign: 'center',
  },
  icon: {
    fontSize: '80px',
    color: theme.palette.grey['600'],
  },
  title: {
    marginTop: '16px',
  },
  text: {
    margin: '8px 0 24px',
    maxWidth: '420px',
  },
}))

const MESSAGES = {
  not_configured: {
    title: 'Portal não configurado para este endereço',
    text:
      'Este endereço ainda não está vinculado a nenhuma mantenedora. Se você chegou aqui por um link oficial, avise a secretaria de educação.',
    retry: false,
  },
  unauthorized: {
    title: 'Não foi possível acessar o portal',
    text:
      'A chave de acesso deste portal foi recusada. Tente novamente em alguns minutos.',
    retry: true,
  },
  error: {
    title: 'Não foi possível carregar o portal',
    text: 'Verifique sua conexão e tente novamente.',
    retry: true,
  },
}

const PortalStatusScreen = ({ status }) => {
  const classes = useStyles()

  if (status === 'loading') {
    return (
      <div className={classes.root} aria-busy="true">
        <CircularProgress size={40} />
      </div>
    )
  }

  const message = MESSAGES[status] || MESSAGES.error

  return (
    <div className={classes.root} role="alert">
      <WarningOutlined className={classes.icon} />
      <Typography className={classes.title} variant="h6" component="h1">
        {message.title}
      </Typography>
      <Typography className={classes.text} variant="body1">
        {message.text}
      </Typography>
      {message.retry && (
        <Button
          variant="contained"
          color="primary"
          onClick={() => window.location.reload()}
        >
          Tentar novamente
        </Button>
      )}
    </div>
  )
}

export default PortalStatusScreen
